import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Label,
    Row,
    Col,
} from 'reactstrap';
import './Notes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faSpinner, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';

class EditNote extends Component {

    render() {

        return (
            <Row key={this.props.row.linkedID} className="notesFormTypeRow text-left">
                <Col sm="8" className="notesFormTypeComments">
                    {this.props.editCategoryCommentsArray.map(comment => {
                        switch (comment.validation) {
                            case "list":
                                return (
                                    <Fragment key={comment.ID}>
                                        <Row key={comment.ID} className="">
                                            {typeof (comment.list) !== 'undefined' ?
                                                <>
                                                    <Label>{comment.type}</Label>
                                                    <Input type="select" name={comment.ID}
                                                        value={isNaN(parseInt(comment.value) && parseInt(comment.value) > 0) ? 0 : parseInt(comment.value)}
                                                        onChange={this.props.changeComment}>
                                                        <option value="0">Select</option>
                                                        {comment.list != null && comment.list.map(item => (
                                                            <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                        ))
                                                        }
                                                    </Input>
                                                </>
                                                :
                                                <></>
                                            }
                                        </Row>
                                        {(this.props.notesCategories.data.reduce((childArray, currentValue) => childArray.concat(currentValue.children), [])
                                            .reduce((listArray, listValue) => listValue.list != null ? listArray.concat(listValue.list) : listArray, [])
                                            .findIndex(item => item.ID === parseInt(comment.value) && item.longDescription === 'Other') > -1) ?
                                            <Row>
                                                <Col md={9} className="px-1 py-1">
                                                    <Input type="text" value={this.props.otherCategories[comment.ID]} onChange={(e) => this.props.changeOtherCategory(comment.ID, e.target.value)} />
                                                </Col>
                                                <Col className="py-1 text-left p-0">
                                                    <Button
                                                        color="success"
                                                        onClick={() => this.props.addCategory(comment.ID, this.props.otherCategories[comment.ID], 'edit')}
                                                        title="Add Other"
                                                    ><FontAwesomeIcon icon={faPlus} /></Button>
                                                </Col>
                                            </Row>
                                            : <></>
                                        }
                                    </Fragment>)
                            case "date":
                                return (<Row key={comment.ID} className="">
                                    <Label>{comment.type}</Label>
                                    <Input name={comment.ID} onChange={this.props.changeComment} value={comment.value} type='date' />
                                </Row>)
                            case "checkbox":
                                return (
                                    <Row key={comment.ID} className="mb-2 pl-4 mt-1">
                                        <Label>
                                            <Input
                                                name={comment.ID}
                                                onChange={this.props.changeComment}
                                                type="checkbox"
                                                checked={comment.value === 'true' || comment.value === true}
                                            />{comment.type}
                                        </Label>
                                    </Row>
                                )
                            case null:
                                return (<Row key={comment.ID} className="">
                                    <Label>{comment.type}</Label>
                                    <Input name={comment.ID} onChange={this.props.changeComment} value={comment.value} type={comment.multiline ? 'textarea' : 'text'} />
                                </Row>)
                            default:
                                return (
                                    <Row key={comment.ID} className="">
                                        <Label>{comment.type} {(comment.validationHint != null) ? <span className="validationHint">({comment.validationHint})</span> : <></>}</Label>
                                        <Input
                                            className={comment.error ? "is-invalid" : ''}
                                            name={comment.ID}
                                            onChange={(e) => this.props.changeComment(e, comment.validation)}
                                            value={comment.value}
                                            type={comment.multiline ? 'textarea' : 'text'} />
                                    </Row>
                                )
                        }
                    })}
                </Col>
                <Col sm="4" className="notesFormTypeControls text-right">
                    <Row>
                        <Col>
                            <Button
                                key={'submit_' + this.props.row.linkedID}
                                color="success"
                                value={this.props.row.linkedID}
                                onClick={this.props.handleEditSubmit}
                                disabled={this.props.loading ||
                                    this.props.isFormBlank(this.props.editCategoryCommentsArray) ||
                                    this.props.editCategoryCommentsArray.filter(item => item.error).length > 0}
                                title="Submit"
                            ><FontAwesomeIcon icon={this.props.loading ? faSpinner : faCheck} /></Button>
                            <ConfirmButton
                                className='mx-2'
                                key={'delete_' + this.props.row.linkedID}
                                color="danger"
                                value={this.props.row.linkedID}
                                onClick={this.props.handleDelete}
                                title="Delete"
                            ><FontAwesomeIcon icon={this.props.loading && this.props.editID === this.props.row.linkedID ? faSpinner : faTrashAlt} /></ConfirmButton>
                            <Button
                                key={'cancel_' + this.props.row.linkedID}
                                color="secondary"
                                // value={this.props.row.linkedID}
                                onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                title="Cancel"
                            ><FontAwesomeIcon icon={faTimes} /></Button>
                        </Col>
                    </Row>
                    {this.props.marketingActivities != null && this.props.marketingActivities.length > 0 && <Row className='mt-3'>
                        <Col>
                            {/* <Label>{comment.type}</Label> */}
                            <Input type="select" 
                                // name={comment.ID}
                                // value={isNaN(parseInt(comment.value) && parseInt(comment.value) > 0) ? 0 : parseInt(comment.value)}
                                // onChange={this.props.changeComment}
                                >
                                {this.props.marketingActivities.length > 1 && <option value="0">Select</option>}
                                {this.props.marketingActivities.map(item => (
                                    <option key={item.ID} value={item.ID}>{item.Item}</option>
                                ))
                                }
                            </Input>
                            <Button
                                color="primary"
                                className="mt-2 w-100 mx-0"
                                // onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                title="Preview Email"
                            >Preview Email</Button>
                            <Button
                                color="success"
                                className="mt-1 w-100 mx-0"
                                // onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                title="Preview Email"
                            >Send Email</Button>
                        </Col>
                    </Row>}
                </Col>
            </Row>
        )
    }
}

export default EditNote;
